export const getYoutubeReportableUrl = (
  requestBodyStr: string
): string | undefined => {
  try {
    const requestBody = JSON.parse(requestBodyStr);
    const { originalUrl } = requestBody.context.client;
    if (isReportableYoutubeEvent(originalUrl)) return originalUrl;
  } catch (e) {
    console.warn('Could not parse request body from YouTube!');
  }
  return undefined;
};

export const isReportableYoutubeAPIEvent = (url: string) =>
  isYoutubeAPIVideo(url) || isYoutubeAPISearch(url);
const isYoutubeAPIVideo = (url: string) =>
  /https?:\/\/((m|www)\.)?youtube\.com\/youtubei\/v1\/player\?/.test(url);
const isYoutubeAPISearch = (url: string) =>
  /https?:\/\/((m|www)\.)?youtube\.com\/youtubei\/v1\/search\?/.test(url);

export const isReportableYoutubeEvent = (url: string) =>
  isYoutubeVideo(url) || isYoutubeSearch(url);
export const isYoutubeVideo = (url: string) =>
  /https?:\/\/((m|www)\.)?youtube\.com\/watch\?/.test(url);
const isYoutubeSearch = (url: string) =>
  /https?:\/\/((m|www)\.)?youtube\.com\/results\?/.test(url);

export interface YouTubeMetadataResponse {
  title?: string;
  author_name?: string;
  // It exists more fields, but we don't need them for now.
}

export const fetchYoutubeMetadata = async (
  url: string
): Promise<YouTubeMetadataResponse> => {
  try {
    const oembedUrl = `https://www.youtube.com/oembed?url=${encodeURIComponent(
      url
    )}&format=json`;
    const response = await fetch(oembedUrl);
    if (!response.ok) {
      throw new Error(`Failed to fetch YouTube metadata: ${response.status}`);
    }
    return (await response.json()) as YouTubeMetadataResponse;
  } catch (error) {
    console.warn('Error fetching YouTube metadata:', error);
    return {};
  }
};
